var map = {
	"./makana-tangy-tamato (1).png": 872,
	"./makana-tangy-tamato (2).png": 4373,
	"./makana-tangy-tamato (3).png": 2174,
	"./makana-tangy-tamato (4).png": 4851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8638;